import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import store from './store'   // 引入 store

Vue.config.productionTip = false
Vue.use(ElementUI)

new Vue({
  router,
  store,   // 注入 store（关键！）
  render: h => h(App)
}).$mount('#app')